import React, { useState } from "react";
import { IconBorderCorners } from "@tabler/icons-react";
import CreateRequest from "./CreateRequest";
import CreateRequestButton from "./CreateRequestButton";

export default function Requests({ requests }) {
  const [creatingNew, setCreatingNew] = useState(false);

  function toggleCreatingNew() {
    setCreatingNew(!creatingNew);
  }

  return (
    <div>
      {!requests.length ? (
        <div className="mb-8 mt-8 text-center">
          <span className="text-xs font-semibold tracking-[0.2em] text-mauve-500">
            GET STARTED
          </span>
          <h3 className="mt-2 text-2xl font-semibold text-mauve-900">
            Create your first request
          </h3>
        </div>
      ) : (
        <div className="mb-4 flex items-center gap-2 font-semibold text-mauve-600">
          <IconBorderCorners className="size-4" stroke={3} />
          <span>Active Requests</span>
        </div>
      )}

      <div className="mb-3">
        {creatingNew ? (
          <CreateRequest setCreatingNew={toggleCreatingNew} />
        ) : (
          <CreateRequestButton setCreatingNew={toggleCreatingNew} />
        )}
      </div>

      {requests}
    </div>
  );
}
